/**=========================================================
 * Module: filewebdav.js
 * FileWebdav Controller
 =========================================================*/

 App.controller('FileWebdavController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'ngDialog',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, ngDialog) {
   "use strict";
   
   $scope.info = $scope.file && $scope.file.info
   if($scope.info && $scope.info.webdav!==null && $scope.info.webdav!==undefined){
       $scope.webdavStatus = $scope.info.webdav
   }

   $scope.retryUpload = function(){
    if($scope.info.webdav===0 || $scope.info.webdav===-1){
        $scope.info.webdav = 2
        R.one('action','PutOnWebdav').customPUT({
            file: $scope.file.id,
            project: $scope.file.entity.split('-')[0] + '-' + $scope.file.entity.split('-')[1]
        }).then(function(response){
            if(response.result){
                $scope.info.webdav = 1
            } else {
                $scope.info.webdav = -1
            }
        })
    }
   }
     
 }
 ]);